import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, ArrowRight } from "lucide-react";
import { FaFacebook, FaInstagram, FaXTwitter, FaLinkedinIn } from "react-icons/fa6";

const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

const COURSES = [
  { label: "Class 8 Foundation", to: "/courses/class-8-foundation" },
  { label: "Class 9 Foundation", to: "/courses/class-9-foundation" },
  { label: "Class 10 Board Prep", to: "/courses/class-10-board-preparation" },
  { label: "Class 11 Foundation", to: "/courses/class-11-foundation" },
  { label: "Class 12 Board Prep", to: "/courses/class-12-board-preparation" },
  { label: "Computer Science", to: "/courses/computer-science" },
];

const QUICK_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Our Faculty", to: "/faculty" },
  { label: "Gallery", to: "/gallery" },
  { label: "Test Series", to: "https://testseries.sssachievers.com/", external: true },
  { label: "Admissions 2026", to: "/admission-open" },
  { label: "Contact Us", to: "/contact" },
];

const SEO_LINKS = [
  { label: "Best Coaching in Ghazipur", to: "/best-coaching-ghazipur" },
  { label: "Maths Tuition Ghazipur", to: "/maths-tuition-ghazipur" },
  { label: "Science Tuition Ghazipur", to: "/science-tuition-ghazipur" },
  { label: "CBSE Coaching Ghazipur", to: "/cbse-coaching-ghazipur" },
  { label: "Class 9 Coaching Ghazipur", to: "/class-9-coaching-ghazipur" },
  { label: "Class 10 Coaching Ghazipur", to: "/class-10-coaching-ghazipur" },
  { label: "Class 8 Foundation Course", to: "/courses/class-8-foundation" },
  { label: "Class 9 Foundation Course", to: "/courses/class-9-foundation" },
  { label: "Class 10 Board Preparation", to: "/courses/class-10-board-preparation" },
  { label: "Class 11 Foundation Course", to: "/courses/class-11-foundation" },
  { label: "Class 12 Board Preparation", to: "/courses/class-12-board-preparation" },
  { label: "Computer Science Coaching", to: "/courses/computer-science" },
  { label: "Coaching in Ghazipur", to: "/best-coaching-ghazipur" },
  { label: "Top Coaching Institute Ghazipur", to: "/best-coaching-ghazipur" },
  { label: "Online Class 10 Tuition", to: "/online-class-10-tuition-ghazipur" },
  { label: "Class 11 & 12 Science Coaching", to: "/class-11-12-science-coaching-ghazipur" },
  { label: "Coaching Centre Near Me", to: "/coaching-centre-near-me-ghazipur" },
  { label: "Admissions 2026", to: "/admission-open" },
];

const POLICY_LINKS = [
  { label: "Terms & Conditions", to: "/terms" },
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Cancellation & Refund", to: "/cancellation-refund" },
];

const SOCIAL = [
  { icon: FaFacebook, href: "https://facebook.com/sssachievers", label: "Facebook", color: "hover:text-blue-400" },
  { icon: FaInstagram, href: "https://instagram.com/sssachievers", label: "Instagram", color: "hover:text-pink-400" },
  { icon: FaXTwitter, href: "https://x.com/SSSAchievers", label: "Twitter / X", color: "hover:text-sky-400" },
  { icon: FaLinkedinIn, href: "https://linkedin.com/company/sssachievers", label: "LinkedIn", color: "hover:text-blue-500" },
];

export default function Footer() {
  const openWhatsApp = () => {
    const msg = "Hello SSS Achievers, I would like to enquire about admissions.";
    window.open(`https://wa.me/919918519991?text=${encodeURIComponent(msg)}`, "_blank");
  };

  return (
    <footer className="bg-gray-950 text-gray-300">

      {/* ── CTA Banner ── */}
      <div className="bg-gradient-to-r from-[#0097b2] to-[#006f85]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-white">
                Ready to Start Your Journey?
              </h2>
              <p className="mt-2 text-blue-100 max-w-xl text-sm md:text-base">
                Join Ghazipur's most trusted coaching institute. Talk to our counsellors
                today — free demo class available.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 shrink-0">
              <a
                href="tel:+919918519991"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white text-[#0097b2] font-semibold rounded hover:bg-blue-50 transition text-sm"
              >
                <Phone className="w-4 h-4" />
                Call Now
              </a>
              <button
                onClick={openWhatsApp}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#fcbf0a] text-gray-900 font-semibold rounded hover:bg-[#e6ac00] transition text-sm"
              >
                Free Demo Class
                <ArrowRight className="w-4 h-4" />
              </button>
            </div>
          </div>

          {/* Address strip */}
          <div className="mt-6 flex items-start gap-2 text-blue-100 text-sm">
            <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
            <span>96/B, Badi Bagh, Opp. Raj Nursing Home, Ghazipur, Uttar Pradesh – 233001</span>
          </div>
        </div>
      </div>

      {/* ── Main Footer Grid ── */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* Brand column */}
          <div className="lg:col-span-1">
            <Link to="/" onClick={scrollTop}>
              <img
                src="/images/sss logo white.png"
                alt="SSS Achievers Logo"
                className="h-14 w-auto object-contain mb-5"
              />
            </Link>
            <p className="text-sm leading-7 text-gray-400">
              <strong className="text-white">SSS Achievers</strong> is Ghazipur's trusted
              coaching institute for Class 8–12. We build strong fundamentals through
              expert mentors, AI smart classrooms, and personalized learning.
            </p>

            {/* Social icons */}
            <div className="flex gap-3 mt-6">
              {SOCIAL.map(({ icon: Icon, href, label, color }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className={`w-9 h-9 rounded-lg bg-gray-800 flex items-center justify-center text-gray-400 ${color} hover:bg-gray-700 transition`}
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Courses */}
          <div>
            <h4 className="text-white font-semibold text-base mb-5 pb-2 border-b border-gray-800">
              Our Courses
            </h4>
            <ul className="space-y-2.5">
              {COURSES.map(({ label, to }) => (
                <li key={to}>
                  <Link
                    to={to}
                    onClick={scrollTop}
                    className="text-sm text-gray-400 hover:text-white transition flex items-center gap-1.5 group"
                  >
                    <ArrowRight className="w-3 h-3 text-[#0097b2] group-hover:translate-x-0.5 transition-transform" />
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-base mb-5 pb-2 border-b border-gray-800">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              {QUICK_LINKS.map(({ label, to, external }) => (
                <li key={to}>
                  {external ? (
                    <a
                      href={to}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-gray-400 hover:text-white transition flex items-center gap-1.5 group"
                    >
                      <ArrowRight className="w-3 h-3 text-[#0097b2] group-hover:translate-x-0.5 transition-transform" />
                      {label}
                    </a>
                  ) : (
                    <Link
                      to={to}
                      onClick={scrollTop}
                      className="text-sm text-gray-400 hover:text-white transition flex items-center gap-1.5 group"
                    >
                      <ArrowRight className="w-3 h-3 text-[#0097b2] group-hover:translate-x-0.5 transition-transform" />
                      {label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-base mb-5 pb-2 border-b border-gray-800">
              Contact Us
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#0097b2] mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-400 leading-relaxed">
                  96/B, Badi Bagh, Opp. Raj Nursing Home,<br />Ghazipur, UP – 233001
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#0097b2] flex-shrink-0" />
                <a
                  href="tel:+919918519991"
                  className="text-sm text-gray-400 hover:text-white transition"
                >
                  +91 99185 19991
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#0097b2] flex-shrink-0" />
                <a
                  href="mailto:info@sssachievers.com"
                  className="text-sm text-gray-400 hover:text-white transition"
                >
                  info@sssachievers.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-4 h-4 text-[#0097b2] mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-400">Mon – Sat: 9:00 AM – 7:00 PM</span>
              </li>
            </ul>

            {/* Map link */}
            <a
              href="https://www.google.com/maps/place/SSS+ACHIEVERS+Coaching+Centre+Ghazipur/@25.5799509,83.5583399,17z/data=!3m1!4b1!4m6!3m5!1s0x2bb0bb23b08ac59:0x4c04724e0b4e6039!8m2!3d25.5799461!4d83.5632108!16s%2Fg%2F11x0dmqx7s?entry=ttu&g_ep=EgoyMDI2MDMzMC4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 mt-5 text-xs text-[#0097b2] hover:text-white transition font-medium"
            >
              <MapPin className="w-3.5 h-3.5" />
              View on Google Maps
            </a>
          </div>

        </div>
      </div>

      {/* ── SEO Links Strip ── */}
      <div className="border-t border-gray-800/60 bg-gray-900/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <p className="text-[10px] text-gray-600 uppercase tracking-widest mb-2 font-medium">
            Explore
          </p>
          <div className="flex flex-wrap gap-x-0 gap-y-1 leading-relaxed">
            {SEO_LINKS.map(({ label, to }, i) => (
              <span key={to + label} className="flex items-center">
                <Link
                  to={to}
                  onClick={scrollTop}
                  className="text-[11px] text-gray-500 hover:text-gray-300 transition-colors"
                >
                  {label}
                </Link>
                {i < SEO_LINKS.length - 1 && (
                  <span className="text-gray-700 mx-2 text-[11px]">|</span>
                )}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* ── Bottom bar ── */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-500 text-center sm:text-left">
            &copy; {new Date().getFullYear()} SSS Achievers, Ghazipur. All rights reserved.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            {POLICY_LINKS.map(({ label, to }) => (
              <Link
                key={to}
                to={to}
                onClick={scrollTop}
                className="text-xs text-gray-500 hover:text-white transition"
              >
                {label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
